import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import styles from "./SettingsItem.module.css";

const SettingsItem = ({
  title,
  options,
  selectedOptions,
  onChange,
  columns,
  children,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleOptionChange = (option) => (event) => {
    const checked = event.target.checked;
    const nextSelection = { ...(selectedOptions || {}) };

    if (checked) {
      nextSelection[option] = true;
    } else {
      delete nextSelection[option];
    }

    onChange?.(nextSelection);
  };

  const normalizedOptions = useMemo(() => options || [], [options]);

  const hasCustomContent = React.Children.count(children) > 0;
  const isDenseFourColumns = !hasCustomContent && columns === 4;
  const optionsStyle =
    !hasCustomContent && columns
      ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }
      : undefined;

  return (
    <div className={styles.container}>
      <button
        type="button"
        className={`${styles.header} ${open ? styles.headerOpen : ""}`}
        onClick={handleToggleOpen}
        aria-expanded={open}
      >
        <span className={styles.title}>{title}</span>
        <span
          className={`${styles.chevron} ${open ? styles.chevronOpen : ""} ${
            styles.chevronRight
          }`}
          aria-hidden
        />
      </button>

      {open && (
        <div
          className={`${styles.options} ${
            isDenseFourColumns ? styles.optionsDenseFour : ""
          }`}
          style={optionsStyle}
        >
          {hasCustomContent ? (
            <div className={styles.customContent}>{children}</div>
          ) : (
            normalizedOptions.map((option) => (
              <label className={styles.option} key={option}>
                <input
                  type="checkbox"
                  className={styles.checkbox}
                  checked={!!selectedOptions?.[option]}
                  onChange={handleOptionChange(option)}
                />
                <span className={styles.optionLabel}>{option}</span>
              </label>
            ))
          )}
        </div>
      )}
    </div>
  );
};

SettingsItem.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  selectedOptions: PropTypes.object, // shape: { [optionLabel]: true }
  onChange: PropTypes.func,
  columns: PropTypes.number,
  children: PropTypes.node,
};

SettingsItem.defaultProps = {
  options: [],
  selectedOptions: {},
  onChange: undefined,
  columns: undefined,
};

export default SettingsItem;
